import i18next from "i18next";

export const _toLegacyDamagedPart = (row, lang) => ({
  ...row,
  damage_part: lang === "da" ? row.text_da : row.text_en,
});

export const _toLegacyMaterial = (row, lang) => ({
  ...row,
  material: lang === "da" ? row.text_da : row.text_en,
});

export const normalizeLang = (value) =>
  String(value || "").toLowerCase().startsWith("da") ? "da" : "en";

export const _resolveLang = () =>
  normalizeLang(i18next.language || localStorage.getItem("i18nextLng"));
